import React from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import { getDistance } from "geolib";
import Routing from "./RoutingMachine";

function MapComponent({ postaja, coords }) {
  const widthToZoom = (width) => {
    width /= 2;
    const earthWidthInMeters = 12742;
    return Math.log(earthWidthInMeters / width) / Math.log(2);
  };

  const center = [coords.latitude, coords.longitude];
  const zoom = widthToZoom(
    getDistance(coords, { latitude: postaja.long, longitude: postaja.lat }) /
      1000
  );

  return (
    <MapContainer
      id="leaflet-map"
      className="postaja-karta"
      center={center}
      zoom={zoom}
      scrollWheelZoom={false}
    >
      <TileLayer
        url={import.meta.env.VITE_TILE_URL}
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
      {coords && <Routing coords={coords} postaja={postaja} />}
    </MapContainer>
  );
}

export default MapComponent;
